import {Injectable, Injector} from '@angular/core';
import {Observable} from 'rxjs';
import {BaseService} from './base.service';
import {Query} from '../../models/query/query';
import {AppModulePath} from '../../models/app-module-path';
import {AppConfiguration} from 'app/models/base/app_configuration';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {catchError, map} from 'rxjs/operators';
import {ClientSettingsService} from '../settings/client-settings.service';

@Injectable()
export class AppConfigurationService extends BaseService {

  private listUrl = '/api/app-configuration/list';
  private readYearUrl = '/api/app-configuration/read-year';
  private changeYearUrl = '/api/app-configuration/change-year';
  private saveUrl = '/api/app-configuration/save';

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation) {
    super(injector, http2, platformLocation);
  }

  list(qry: Query): Observable<AppConfiguration[]> {
    const url = this.listUrl + '?q=' + encodeURIComponent(JSON.stringify(qry));
    return this.get<AppConfiguration[]>(url, AppModulePath.APP_CONFIGURATION).pipe(
      map(res => res.map(obj => new AppConfiguration(obj))),
      catchError(this.handleError));
  }

  changeYear(year: Number): Observable<Number> {
    return this.post<Number>(`${this.changeYearUrl}/${year}`, AppModulePath.APP_CONFIGURATION, null).pipe(
      map(res => {
        return res;
      }),
      catchError(this.handleError));
  }

  readYear(): Observable<Number> {
    return this.get<Number>(this.readYearUrl, AppModulePath.APP_CONFIGURATION).pipe(
      map(res  => {
        console.log(res);
        return res;
      }),
      catchError(this.handleError));
  }

  save(config: AppConfiguration): Observable<AppConfiguration> {
    return this.post<AppConfiguration>(this.saveUrl, AppModulePath.APP_CONFIGURATION, config).pipe(
      map(res => new AppConfiguration(res)),
      catchError(this.handleError)
    );
  }
  
}
